import React from 'react';
import { Segment, Label, Grid } from 'semantic-ui-react';

const TableLegend = ({ hasPermission, items = {} }) => {
    const visibleItems = Object.values(items).filter(item =>
        hasPermission(item.permission[0], item.permission[1])
    );

    if (visibleItems.length === 0) return null;

    return (
        <Segment style={{ marginBottom: '1em', maxWidth: '700px' }}>
            <Grid>
                <Grid.Row>
                    <Grid.Column>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1em' }}>
                            {visibleItems.map((item, index) => (
                                <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '0.5em' }}>
                                    <Label size='tiny' color={item.color}>
                                        <i className={`${item.icon} icon`} style={{ margin: 0 }}></i>
                                    </Label>
                                    <span style={{ fontSize: '0.9em', color: 'rgba(0,0,0,0.7)' }}>
                                        {item.label}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Segment>
    );
};

export default TableLegend;